export default __webpack_public_path__ + "states.jpg?bdbf217a71636f2c7d776b7287b2195f";